import BasicPriceOrInvoiceValue from "./BasicPriceOrInvoiceValue";

export default BasicPriceOrInvoiceValue;
